import { render, staticRenderFns } from "./ProductPriceList.vue?vue&type=template&id=2b906ef3&class=productPrice"
import script from "./ProductPriceList.vue?vue&type=script&lang=js"
export * from "./ProductPriceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports